const BLOG_SETTINGS = {
  LISTING: {
    DEFAULT_LIMIT: 6,
    LOAD_ARTICLES_COUNT: 3,
  },
  ARTICLE: {
    DEFAULT_LIMIT: 3,
    LOAD_ARTICLES_COUNT: 3,
  },
  ARTICLE_CHARS_LIMIT: 150,
  ARTICLE_SEO_DESCRIPTION_LIMIT: 200,
};

  // todo - lang service !!
const DEFAULT_BLOG_FILTER = {
  name: 'all articles',
  value: '',
};

export { BLOG_SETTINGS, DEFAULT_BLOG_FILTER };



// WEBPACK FOOTER //
// ./src/common/consts/blog.js